import { __generator } from "tslib";
import ddt from '@wix/da-ddt';
import { Url } from '@wix/da-url';
import { select, takeLatest, call } from 'redux-saga/effects';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { logBiEvent } from '../../biLogger/redux/saga';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { loadDuperbrowseItem } from '../../Duperbrowse/redux/actionCreators';
import { getLoadCount } from '../../Duperbrowse/redux/selectors';
import { getDuperRedirectThreshold } from './selectors';
import { flagEnabled } from '../flags/selectors';
var logger = ddt.createLogger('sisufunnel');
function handleLoading(_a) {
    var loadCount, threshold, ads_nitro, data;
    var itemSchema = _a.payload.itemSchema;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (itemSchema !== 'deviation') {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getLoadCount)];
            case 1:
                loadCount = _b.sent();
                logger.log('Duperbrowse load count: ', loadCount);
                return [4 /*yield*/, select(getDuperRedirectThreshold)];
            case 2:
                threshold = _b.sent();
                return [4 /*yield*/, select(flagEnabled, 'ads_nitro')];
            case 3:
                ads_nitro = _b.sent();
                if (ads_nitro) {
                    return [2 /*return*/];
                }
                if (!(loadCount > threshold)) return [3 /*break*/, 5];
                data = {
                    evid: BiEventType.REDIRECT_TO_LOGIN,
                    referral_info: ReferralType.SISU_FUNNEL_NEXT_DEVIATION,
                };
                return [4 /*yield*/, call(logBiEvent, data)];
            case 4:
                _b.sent();
                window.location.assign(Url.joinLink());
                _b.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
export function sisuFunnelSaga() {
    var loggedIn;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                loggedIn = _a.sent();
                if (loggedIn) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, takeLatest(loadDuperbrowseItem, handleLoading)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map